<div class="modal-header">
  <h5 class="modal-title">Резервные коды 2FA</h5>
  <button type="button" class="close" (click)="activeModal.dismiss()">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body">

  <!-- Шаг 1: ввод TOTP-кода -->
  <ng-container *ngIf="step === 'code'">
    <p class="mb-2">
      Введите текущий 6-значный код из приложения-аутентификатора.
      После этого старые резервные коды перестанут работать и будут выпущены новые.
    </p>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label class="form-label" for="backup-totp-code">Код из приложения:</label>
        <input type="text"
               id="backup-totp-code"
               formControlName="code"
               class="form-control"
               placeholder="000000"
               maxlength="6"
               autocomplete="one-time-code"
               [class.is-invalid]="form.get('code').errors && form.get('code').touched"
        />
        <small *ngIf="form.get('code').errors?.required && form.get('code').touched"
               class="text-danger font-weight-bold">
          Поле обязательно
        </small>
        <small *ngIf="form.get('code').errors?.minlength && form.get('code').touched"
               class="text-danger font-weight-bold">
          Код состоит из 6 цифр
        </small>
      </div>
      <button type="submit"
              class="btn btn-primary d-flex justify-content-center"
              rippleEffect
              [disabled]="form.invalid || isLoading"
      >
        <loader class="mr-1 btn-loader" *ngIf="isLoading"></loader>
        <span>Выпустить новые коды</span>
      </button>
    </form>
  </ng-container>

  <!-- Шаг 2: показ новых backup-кодов -->
  <ng-container *ngIf="step === 'backup'">
    <p class="mb-1">
      Сохраните коды в надёжном месте.
      <strong>Они показываются только один раз.</strong>
    </p>
    <div class="backup-codes-grid mb-2">
      <div *ngFor="let code of backupCodes">
        <code class="font-small-2">{{code}}</code>
      </div>
    </div>
    <button type="button"
            class="btn btn-outline-secondary mr-1"
            rippleEffect
            (click)="copyBackupCodes()"
    >
      <span [data-feather]="'copy'" class="mr-50"></span>
      <span>{{copied ? 'Скопировано!' : 'Скопировать'}}</span>
    </button>
    <button type="button"
            class="btn btn-primary"
            rippleEffect
            (click)="activeModal.close()"
    >
      Готово
    </button>
  </ng-container>

</div>
